function getDelay(el) {
  const grid = el.closest('[data-grid]');
  if (!grid) return 0;
  return [...grid.querySelectorAll('[data-observe]')].indexOf(el) * 0.1;
}

const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (!entry.isIntersecting) return;
    const el = entry.target;
    el.style.setProperty('--delay', `${getDelay(el)}s`);
    el.classList.add('is-visible');
    observer.unobserve(el);
  });
}, { threshold: 0 });

document.querySelectorAll('[data-observe]').forEach(el => observer.observe(el));
